/**
 * @auth 赖传峰
 * @date 2022/5/3
 */
import DownloadIcon from '@/components/icons/DownloadIcon.vue'
import OpenIcon from '@/components/icons/OpenIcon.vue'
import RestoreIcon from '@/components/icons/RestoreIcon.vue'
import WarningIcon from '@/components/icons/WarningIcon.vue'
import SaveSuccessBar from '@/components/share/SaveSuccessBar.vue'
import { type CSSProperties } from 'vue'
import { Operation, OperationGroup, type OperationMeta } from './contextMenu.type'

/**
 * 计算右键菜单显示的位置
 * @param pointerCoordinate {number} 鼠标的坐标
 * @param eltSize {number} 菜单的尺寸
 * @param windowSize {number} 视窗的尺寸
 */
export const computePosition = (pointerCoordinate: number, eltSize: number, windowSize: number): number =>
  pointerCoordinate + eltSize > windowSize ? pointerCoordinate - eltSize : pointerCoordinate

/* 从样式属性中提取数字 */
export const sizeStyle2Number = (style: string | `${number}px`): number => Number(style.replace('px', ''))

/**
 * @param pointerCoordinate 鼠标指针或者触发元素的坐标
 * @param eltCoordinate 右键菜单左上角的定位坐标
 */
export const computeTransformOrigin = (
  pointerCoordinate: { x: number; y: number },
  eltCoordinate: { x: number; y: number },
): CSSProperties['transform-origin'] =>
  `${pointerCoordinate.y > eltCoordinate.y ? 'bottom' : 'top'} ${
    pointerCoordinate.x > eltCoordinate.x ? 'right' : 'left'
  }`

export const operationsMeta: OperationMeta[] = [
  {
    operation: Operation.OPEN,
    labelI18nKey: 'open',
    icon: OpenIcon,
    limit: (_, ids) => ids?.length === 1,
  },
  {
    operation: Operation.RESTORE,
    labelI18nKey: 'restore',
    icon: RestoreIcon,
    limit: (_, ids) => (ids ? ids.length > 0 : false),
  },
  {
    operation: Operation.DOWNLOAD_GUIDE,
    labelI18nKey: 'download',
    icon: DownloadIcon,
    limit: () => true, // 总是显示下载指南选项
    hideInBottom: true, // 中间底部的操作栏是否隐藏
  },
  {
    operation: Operation.REPORT,
    labelI18nKey: 'report',
    icon: WarningIcon,
    limit: () => true, // 总是显示举报选项
    hideInBottom: true, // 中间底部的操作栏是否隐藏
  },
  {
    group: OperationGroup.STATUS,
    operation: 'restore-success',
    labelI18nKey: '',
    icon: SaveSuccessBar,
    limit: (_, __, showRestoreStatus) => !!showRestoreStatus,
  },
]

export const ContextMenuEventName = Symbol('context-menu')
